<template>
  <div class="wrap">
    <input type="text" placeholder="icon name" class="form-control" v-model="search">
    <div class="my-4">flaticon</div>
    <div>
      <i v-for="(item, index) in flaticonList.list" :key="index" :class="'flaticon-'+item" :title="'flaticon-'+item"></i>
    </div>

    <div class="my-4">flaticon2</div>
    <div>
      <i v-for="(item, index) in flaticon2List.list" :key="index" :class="'flaticon2-'+item" :title="'flaticon2-'+item"></i>
    </div>

    <div class="my-4">line awesome</div>
    <div>
      <i v-for="(item, index) in lineAwesomeList.list" :key="index" :class="'la la-'+item" :title="'la la-'+item"></i>
    </div>

    <div class="my-4">simple lines</div>
    <div>
      <i v-for="(item, index) in simpleLinesList.list" :key="index" :class="'icon-'+item" :title="'icon-'+item"></i>
    </div>

    <div class="my-4">font awesome</div>
    <div>
      <i v-for="(item, index) in fontAwesomeList.list" :key="index" :class="'fa fa-'+item" :title="'fa fa-'+item"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    flaticon: [
    "email-black-circular-button",
    "map",
    "alert-off",
    "alert",
    "computer",
    "responsive",
    "presentation",
    "arrows",
    "rocket",
    "reply",
    "gift",
    "confetti",
    "piggy-bank",
    "support",
    "delete",
    "eye",
    "multimedia",
    "whatsapp",
    "multimedia-2",
    "email",
    "presentation-1",
    "trophy",
    "psd",
    "layer",
    "doc",
    "file",
    "network",
    "bus-stop",
    "globe",
    "upload",
    "squares",
    "technology",
    "up-arrow",
    "browser",
    "speech-bubble",
    "coins",
    "open-box",
    "speech-bubble-1",
    "attachment",
    "photo-camera",
    "skype-logo",
    "linkedin-logo",
    "twitter-logo",
    "facebook-letter-logo",
    "calendar-with-a-clock-time-tools",
    "youtube",
    "add-circular-button",
    "more-v2",
    "search",
    "search-magnifier-interface-symbol",
    "questions-circular-button",
    "refresh",
    "logout",
    "event-calendar-symbol",
    "laptop",
    "tool",
    "graphic",
    "symbol",
    "graphic-1",
    "clock",
    "squares-1",
    "black",
    "book",
    "cogwheel",
    "exclamation",
    "add-label-button",
    "delete-1",
    "interface",
    "more",
    "warning-sign",
    "calendar",
    "instagram-logo",
    "linkedin",
    "facebook-logo-button",
    "twitter-logo-button",
    "cancel",
    "exclamation-square",
    "buildings",
    "danger",
    "technology-1",
    "letter-g",
    "interface-1",
    "circle",
    "pin",
    "close",
    "clock-1",
    "apps",
    "user",
    "menu-button",
    "settings",
    "home",
    "clock-2",
    "lifebuoy",
    "cogwheel-1",
    "paper-plane",
    "statistics",
    "diagram",
    "line-graph",
    "customer",
    "visible",
    "shopping-basket",
    "price-tag",
    "businesswoman",
    "medal",
    "like",
    "edit",
    "avatar",
    "download",
    "home-1",
    "mail",
    "mail-1",
    "warning",
    "cart",
    "bag",
    "pie-chart",
    "graph",
    "interface-2",
    "chat",
    "envelope",
    "chat-1",
    "interface-3",
    "background",
    "file-1",
    "interface-4",
    "multimedia-3",
    "list",
    "time",
    "profile",
    "imac",
    "medical",
    "music",
    "plus",
    "exclamation-1",
    "info",
    "menu-1",
    "menu-2",
    "share",
    "interface-5",
    "signs",
    "tabs",
    "multimedia-4",
    "upload-1",
    "web",
    "placeholder",
    "placeholder-1",
    "layers",
    "interface-6",
    "interface-7",
    "interface-8",
    "tool-1",
    "settings-1",
    "alarm",
    "search-1",
    "time-1",
    "stopwatch",
    "folder",
    "folder-1",
    "folder-2",
    "folder-3",
    "file-2",
    "list-1",
    "list-2",
    "calendar-1",
    "time-2",
    "interface-9",
    "app",
    "suitcase",
    "grid-menu-v2",
    "more-v6",
    "more-v5",
    "add",
    "multimedia-5",
    "more-v4",
    "placeholder-2",
    "map-location",
    "users",
    "profile-1",
    "lock",
    "sound",
    "star",
    "placeholder-3",
    "bell",
    "paper-plane-1",
    "users-1",
    "more-1",
    "up-arrow-1",
    "grid-menu",
    "alarm-1",
    "earth-globe",
    "alert-1",
    "internet",
    "user-ok",
    "user-add",
    "user-settings",
    "truck",
    "analytics",
    "notes",
    "tea-cup",
    "exclamation-2",
    "technology-2",
    "location",
    "edit-1",
    "home-2",
    "dashboard",
    "information",
    "light",
    "car",
    "business",
    "squares-2",
    "signs-1",
    "mark",
    "squares-3",
    "comment",
    "shapes",
    "clipboard",
    "squares-4",
    "delete-2",
    "bell-1",
    "list-3",
    "infinity",
    "chat-2",
    "calendar-2",
    "signs-2",
    "time-3",
    "calendar-3",
    "interface-10",
    "interface-11",
    "folder-4",
    "alert-2",
    "cogwheel-2",
    "graphic-2",
    "rotate",
    "feed",
    "safe-shield-protection",
    "security",
    "download-1",
    "pie-chart-1",
    "notepad",
    ],
    flaticon2: [
    "notification",
    "settings",
    "search",
    "delete",
    "psd",
    "list",
    "box",
    "download",
    "shield",
    "paperplane",
    "avatar",
    "bell",
    "fax",
    "chart2",
    "supermarket",
    "phone",
    "envelope",
    "pin",
    "chat",
    "chart",
    "infographic",
    "grids",
    "menu",
    "plus",
    "list-1",
    "talk",
    "file",
    "user",
    "line-chart",
    "percentage",
    "menu-1",
    "paper-plane",
    "menu-2",
    "shopping-cart",
    "pie-chart",
    "box-1",
    "map",
    "favourite",
    "checking",
    "safe",
    "heart-rate-monitor",
    "layers",
    "delivery-package",
    "sms",
    "image-file",
    "plus-1",
    "send",
    "graphic-design",
    "cup",
    "website",
    "gift",
    "chronometer",
    "bar-chart",
    "browser",
    "digital-marketing",
    "calendar",
    "calendar-1",
    "rocket",
    "analytics",
    "pie-chart-1",
    "pie-chart-2",
    "analytics-1",
    "google-drive-file",
    "pie-chart-3",
    "poll-symbol",
    "gear",
    "magnifier-tool",
    "add",
    "cube",
    "gift-1",
    "list-2",
    "shopping-cart-1",
    "calendar-2",
    "laptop",
    "cube-1",
    "layers-1",
    "chat-1",
    "copy",
    "paper",
    "hospital",
    "calendar-3",
    "speaker",
    "pie-chart-4",
    "schedule",
    "expand",
    "menu-3",
    "download-1",
    "help",
    "list-3",
    "notepad",
    "graph",
    "browser-1",
    "photograph",
    "browser-2",
    "hourglass",
    "mail",
    "cardiogram",
    "document",
    "contract",
    "graph-1",
    "graphic",
    "position",
    "soft-icons",
    "circle-vol-2",
    "rocket-1",
    "lorry",
    "cd",
    "file-1",
    "reload",
    "placeholder",
    "refresh",
    "medical-records",
    "rectangular",
    "medical-records-1",
    "indent-dots",
    "search-1",
    "edit",
    "new-email",
    "calendar-4",
    "add-circular-button",
    "close-cross",
    "attention",
    "information",
    "rocket-2",
    "maps",
    "link",
    "download-symbol",
    "power",
    "console",
    "open-text-book",
    "download-2",
    "zig-zag-line-sign",
    "tools-and-utensils",
    "crisp-icons",
    "trash",
    "lock",
    "bell-1",
    "bell-alarm-symbol",
    "setup",
    "menu-4",
    "architecture-and-city",
    "shelter",
    "add-1",
    "checkmark",
    "circular-arrow",
    "user-outline-symbol",
    "rhombus",
    "crisp-icons-1",
    "soft-icons-1",
    "hexagonal",
    "time",
    "contrast",
    "note",
    "telegram-logo",
    "hangouts-logo",
    "analytics-2",
    "wifi",
    "protected",
    "drop",
    "mail-1",
    "delivery-truck",
    "writing",
    "calendar-5",
    "protection",
    "calendar-6",
    "calendar-7",
    "calendar-8",
    "bell-2",
    "hourglass-1",
    "next",
    "chat-2",
    "correct",
    "right-arrow",
    "down-arrow",
    "photo-camera",
    "fast-next",
    "fast-back",
    "down",
    "back",
    "up",
    "arrow-down",
    "arrow-up",
    "accept",
    "sort",
    "arrow",
    "back-1",
    "add-square",
    "quotation-mark",
    "clip-symbol",
    "check-mark",
    "folder",
    "cancel-music",
    "cross",
    "pen",
    "email",
    "graph-2",
    "open-box",
    "files-and-folders",
    "ui",
    "sheet",
    "dashboard",
    "user-1",
    "group",
    ],
    lineAwesome: [
    "500px",
    "adjust",
    "adn",
    "align-center",
    "align-justify",
    "align-left",
    "align-right",
    "amazon",
    "ambulance",
    "anchor",
    "android",
    "angellist",
    "angle-double-down",
    "angle-double-left",
    "angle-double-right",
    "angle-double-up",
    "angle-down",
    "angle-left",
    "angle-right",
    "angle-up",
    "apple",
    "archive",
    "area-chart",
    "arrow-circle-down",
    "arrow-circle-left",
    "arrow-circle-o-down",
    "arrow-circle-o-left",
    "arrow-circle-o-right",
    "arrow-circle-o-up",
    "arrow-circle-right",
    "arrow-circle-up",
    "arrow-down",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "arrows",
    "arrows-alt",
    "arrows-h",
    "arrows-v",
    "asterisk",
    "at",
    "automobile",
    "backward",
    "balance-scale",
    "ban",
    "bank",
    "bar-chart",
    "bar-chart-o",
    "barcode",
    "bars",
    "battery-0",
    "battery-1",
    "battery-2",
    "battery-3",
    "battery-4",
    "battery-empty",
    "battery-full",
    "battery-half",
    "battery-quarter",
    "battery-three-quarters",
    "bed",
    "beer",
    "behance",
    "behance-square",
    "bell",
    "bell-o",
    "bell-slash",
    "bell-slash-o",
    "bicycle",
    "binoculars",
    "birthday-cake",
    "bitbucket",
    "bitbucket-square",
    "bitcoin",
    "black-tie",
    "bold",
    "bolt",
    "bomb",
    "book",
    "bookmark",
    "bookmark-o",
    "briefcase",
    "btc",
    "bug",
    "building",
    "building-o",
    "bullhorn",
    "bullseye",
    "bus",
    "buysellads",
    "cab",
    "calculator",
    "calendar",
    "calendar-check-o",
    "calendar-minus-o",
    "calendar-o",
    "calendar-plus-o",
    "calendar-times-o",
    "camera",
    "camera-retro",
    "car",
    "caret-down",
    "caret-left",
    "caret-right",
    "caret-square-o-down",
    "caret-square-o-left",
    "caret-square-o-right",
    "caret-square-o-up",
    "caret-up",
    "cart-arrow-down",
    "cart-plus",
    "cc",
    "cc-amex",
    "cc-diners-club",
    "cc-discover",
    "cc-jcb",
    "cc-mastercard",
    "cc-paypal",
    "cc-stripe",
    "cc-visa",
    "certificate",
    "chain",
    "chain-broken",
    "check",
    "check-circle",
    "check-circle-o",
    "check-square",
    "check-square-o",
    "chevron-circle-down",
    "chevron-circle-left",
    "chevron-circle-right",
    "chevron-circle-up",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "child",
    "chrome",
    "circle",
    "circle-o",
    "circle-o-notch",
    "circle-thin",
    "clipboard",
    "clock-o",
    "clone",
    "close",
    "cloud",
    "cloud-download",
    "cloud-upload",
    "cny",
    "code",
    "code-fork",
    "codepen",
    "coffee",
    "cog",
    "cogs",
    "columns",
    "comment",
    "comment-o",
    "commenting",
    "commenting-o",
    "comments",
    "comments-o",
    "compass",
    "compress",
    "connectdevelop",
    "contao",
    "copy",
    "copyright",
    "creative-commons",
    "credit-card",
    "crop",
    "crosshairs",
    "css3",
    "cube",
    "cubes",
    "cut",
    "cutlery",
    "dashboard",
    "dashcube",
    "database",
    "dedent",
    "delicious",
    "desktop",
    "deviantart",
    "diamond",
    "digg",
    "dollar",
    "dot-circle-o",
    "download",
    "dribbble",
    "dropbox",
    "drupal",
    "edit",
    "eject",
    "ellipsis-h",
    "ellipsis-v",
    "empire",
    "envelope",
    "envelope-o",
    "envelope-square",
    "eraser",
    "eur",
    "euro",
    "exchange",
    "exclamation",
    "exclamation-circle",
    "exclamation-triangle",
    "expand",
    "expeditedssl",
    "external-link",
    "external-link-square",
    "eye",
    "eye-slash",
    "eyedropper",
    "facebook",
    "facebook-official",
    "facebook-square",
    "fast-backward",
    "fast-forward",
    "fax",
    "female",
    "fighter-jet",
    "file",
    "file-archive-o",
    "file-audio-o",
    "file-code-o",
    "file-excel-o",
    "file-image-o",
    "file-movie-o",
    "file-o",
    "file-pdf-o",
    "file-photo-o",
    "file-picture-o",
    "file-powerpoint-o",
    "file-sound-o",
    "file-text",
    "file-text-o",
    "file-video-o",
    "file-word-o",
    "file-zip-o",
    "files-o",
    "film",
    "filter",
    "fire",
    "fire-extinguisher",
    "firefox",
    "flag",
    "flag-checkered",
    "flag-o",
    "flash",
    "flask",
    "flickr",
    "floppy-o",
    "folder",
    "folder-o",
    "folder-open",
    "folder-open-o",
    "font",
    "fonticons",
    "forumbee",
    "forward",
    "foursquare",
    "frown-o",
    "futbol-o",
    "gamepad",
    "gavel",
    "gbp",
    "gear",
    "gears",
    "genderless",
    "get-pocket",
    "gg",
    "gg-circle",
    "gift",
    "git",
    "git-square",
    "github",
    "github-alt",
    "github-square",
    "glass",
    "globe",
    "google",
    "google-plus",
    "google-plus-square",
    "google-wallet",
    "graduation-cap",
    "gratipay",
    "group",
    "h-square",
    "hacker-news",
    "hand-grab-o",
    "hand-lizard-o",
    "hand-o-down",
    "hand-o-left",
    "hand-o-right",
    "hand-o-up",
    "hand-paper-o",
    "hand-peace-o",
    "hand-pointer-o",
    "hand-rock-o",
    "hand-scissors-o",
    "hand-spock-o",
    "hand-stop-o",
    "hdd-o",
    "header",
    "headphones",
    "heart",
    "heart-o",
    "heartbeat",
    "history",
    "home",
    "hospital-o",
    "hotel",
    "hourglass",
    "hourglass-1",
    "hourglass-2",
    "hourglass-3",
    "hourglass-end",
    "hourglass-half",
    "hourglass-o",
    "hourglass-start",
    "houzz",
    "html5",
    "i-cursor",
    "ils",
    "image",
    "inbox",
    "indent",
    "industry",
    "info",
    "info-circle",
    "inr",
    "instagram",
    "institution",
    "internet-explorer",
    "ioxhost",
    "italic",
    "joomla",
    "jpy",
    "jsfiddle",
    "key",
    "keyboard-o",
    "krw",
    "language",
    "laptop",
    "lastfm",
    "lastfm-square",
    "leaf",
    "leanpub",
    "legal",
    "lemon-o",
    "level-down",
    "level-up",
    "life-bouy",
    "life-buoy",
    "life-ring",
    "life-saver",
    "lightbulb-o",
    "line-chart",
    "link",
    "linkedin",
    "linkedin-square",
    "linux",
    "list",
    "list-alt",
    "list-ol",
    "list-ul",
    "location-arrow",
    "lock",
    "long-arrow-down",
    "long-arrow-left",
    "long-arrow-right",
    "long-arrow-up",
    "magic",
    "magnet",
    "mail-forward",
    "mail-reply",
    "mail-reply-all",
    "male",
    "map",
    "map-marker",
    "map-o",
    "map-pin",
    "map-signs",
    "mars",
    "mars-double",
    "mars-stroke",
    "mars-stroke-h",
    "mars-stroke-v",
    "maxcdn",
    "meanpath",
    "medium",
    "medkit",
    "meh-o",
    "mercury",
    "microphone",
    "microphone-slash",
    "minus",
    "minus-circle",
    "minus-square",
    "minus-square-o",
    "mobile",
    "mobile-phone",
    "money",
    "moon-o",
    "mortar-board",
    "motorcycle",
    "mouse-pointer",
    "music",
    "navicon",
    "neuter",
    "newspaper-o",
    "object-group",
    "object-ungroup",
    "odnoklassniki",
    "odnoklassniki-square",
    "opencart",
    "openid",
    "opera",
    "optin-monster",
    "outdent",
    "pagelines",
    "paint-brush",
    "paper-plane",
    "paper-plane-o",
    "paperclip",
    "paragraph",
    "paste",
    "pause",
    "paw",
    "paypal",
    "pencil",
    "pencil-square",
    "pencil-square-o",
    "phone",
    "phone-square",
    "photo",
    "picture-o",
    "pie-chart",
    "pied-piper",
    "pied-piper-alt",
    "pinterest",
    "pinterest-p",
    "pinterest-square",
    "plane",
    "play",
    "play-circle",
    "play-circle-o",
    "plug",
    "plus",
    "plus-circle",
    "plus-square",
    "plus-square-o",
    "power-off",
    "print",
    "puzzle-piece",
    "qq",
    "qrcode",
    "question",
    "question-circle",
    "quote-left",
    "quote-right",
    "ra",
    "random",
    "rebel",
    "recycle",
    "reddit",
    "reddit-square",
    "refresh",
    "registered",
    "renren",
    "reorder",
    "repeat",
    "reply",
    "reply-all",
    "retweet",
    "rmb",
    "road",
    "rocket",
    "rotate-left",
    "rotate-right",
    "rouble",
    "rss",
    "rss-square",
    "rub",
    "ruble",
    "rupee",
    "safari",
    "save",
    "scissors",
    "search",
    "search-minus",
    "search-plus",
    "sellsy",
    "server",
    "share",
    "share-alt",
    "share-alt-square",
    "share-square",
    "share-square-o",
    "shekel",
    "sheqel",
    "shield",
    "ship",
    "shirtsinbulk",
    "shopping-cart",
    "sign-in",
    "sign-out",
    "signal",
    "simplybuilt",
    "sitemap",
    "skyatlas",
    "skype",
    "slack",
    "sliders",
    "slideshare",
    "smile-o",
    "sort",
    "sort-alpha-asc",
    "sort-alpha-desc",
    "sort-amount-asc",
    "sort-amount-desc",
    "sort-asc",
    "sort-desc",
    "sort-numeric-asc",
    "sort-numeric-desc",
    "soundcloud",
    "space-shuttle",
    "spinner",
    "spoon",
    "spotify",
    "square",
    "square-o",
    "stack-exchange",
    "stack-overflow",
    "star",
    "star-half",
    "star-half-o",
    "star-o",
    "steam",
    "steam-square",
    "step-backward",
    "step-forward",
    "stethoscope",
    "sticky-note",
    "sticky-note-o",
    "stop",
    "street-view",
    "strikethrough",
    "stumbleupon",
    "stumbleupon-circle",
    "subscript",
    "subway",
    "suitcase",
    "sun-o",
    "superscript",
    "table",
    "tablet",
    "tachometer",
    "tag",
    "tags",
    "tasks",
    "taxi",
    "television",
    "tencent-weibo",
    "terminal",
    "text-height",
    "text-width",
    "th",
    "th-large",
    "th-list",
    "thumb-tack",
    "thumbs-down",
    "thumbs-o-down",
    "thumbs-o-up",
    "thumbs-up",
    "ticket",
    "times",
    "times-circle",
    "times-circle-o",
    "tint",
    "toggle-off",
    "toggle-on",
    "trademark",
    "train",
    "transgender",
    "transgender-alt",
    "trash",
    "trash-o",
    "tree",
    "trello",
    "tripadvisor",
    "trophy",
    "truck",
    "try",
    "tty",
    "tumblr",
    "tumblr-square",
    "turkish-lira",
    "twitch",
    "twitter",
    "twitter-square",
    "umbrella",
    "underline",
    "undo",
    "university",
    "unlink",
    "unlock",
    "unlock-alt",
    "upload",
    "usd",
    "user",
    "user-md",
    "user-plus",
    "user-secret",
    "user-times",
    "users",
    "venus",
    "venus-double",
    "venus-mars",
    "viacoin",
    "video-camera",
    "vimeo",
    "vimeo-square",
    "vine",
    "vk",
    "volume-down",
    "volume-off",
    "volume-up",
    "warning",
    "wechat",
    "weibo",
    "weixin",
    "whatsapp",
    "wheelchair",
    "wifi",
    "wikipedia-w",
    "windows",
    "won",
    "wordpress",
    "wrench",
    "xing",
    "xing-square",
    "y-combinator",
    "y-combinator-square",
    "yahoo",
    "yc",
    "yc-square",
    "yelp",
    "yen",
    "youtube",
    "youtube-play",
    "youtube-square",
    ],
    simpleLines:[
    "user",
    "people",
    "user-female",
    "user-follow",
    "user-following",
    "user-unfollow",
    "login",
    "logout",
    "emotsmile",
    "phone",
    "call-end",
    "call-in",
    "call-out",
    "map",
    "location-pin",
    "direction",
    "directions",
    "compass",
    "layers",
    "menu",
    "list",
    "options-vertical",
    "options",
    "arrow-down",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "arrow-up-circle",
    "arrow-left-circle",
    "arrow-right-circle",
    "arrow-down-circle",
    "check",
    "clock",
    "plus",
    "minus",
    "close",
    "event",
    "exclamation",
    "organization",
    "trophy",
    "screen-smartphone",
    "screen-desktop",
    "plane",
    "notebook",
    "mustache",
    "mouse",
    "magnet",
    "energy",
    "disc",
    "cursor",
    "cursor-move",
    "crop",
    "chemistry",
    "speedometer",
    "shield",
    "screen-tablet",
    "magic-wand",
    "hourglass",
    "graduation",
    "ghost",
    "game-controller",
    "fire",
    "eyeglass",
    "envelope-open",
    "envelope-letter",
    "bell",
    "badge",
    "anchor",
    "wallet",
    "vector",
    "speech",
    "puzzle",
    "printer",
    "present",
    "playlist",
    "pin",
    "picture",
    "handbag",
    "globe-alt",
    "globe",
    "folder-alt",
    "folder",
    "film",
    "feed",
    "drop",
    "drawer",
    "docs",
    "doc",
    "diamond",
    "cup",
    "calculator",
    "bubbles",
    "briefcase",
    "book-open",
    "basket-loaded",
    "basket",
    "bag",
    "action-undo",
    "action-redo",
    "wrench",
    "umbrella",
    "trash",
    "tag",
    "support",
    "frame",
    "size-fullscreen",
    "size-actual",
    "shuffle",
    "share-alt",
    "share",
    "rocket",
    "question",
    "pie-chart",
    "pencil",
    "note",
    "loop",
    "home",
    "grid",
    "graph",
    "microphone",
    "music-tone-alt",
    "music-tone",
    "earphones-alt",
    "earphones",
    "equalizer",
    "like",
    "dislike",
    "control-start",
    "control-rewind",
    "control-play",
    "control-pause",
    "control-forward",
    "control-end",
    "volume-1",
    "volume-2",
    "volume-off",
    "calendar",
    "bulb",
    "chart",
    "ban",
    "bubble",
    "camrecorder",
    "camera",
    "cloud-download",
    "cloud-upload",
    "envelope",
    "eye",
    "flag",
    "heart",
    "info",
    "key",
    "link",
    "lock",
    "lock-open",
    "magnifier",
    "magnifier-add",
    "magnifier-remove",
    "paper-clip",
    "paper-plane",
    "power",
    "refresh",
    "reload",
    "settings",
    "star",
    "symbol-female",
    "symbol-male",
    "target",
    "credit-card",
    "paypal",
    "social-tumblr",
    "social-twitter",
    "social-facebook",
    "social-instagram",
    "social-linkedin",
    "social-pinterest",
    "social-github",
    "social-google",
    "social-reddit",
    "social-skype",
    "social-dribbble",
    "social-behance",
    "social-foursqare",
    "social-soundcloud",
    "social-spotify",
    "social-stumbleupon",
    "social-youtube",
    "social-dropbox",
    "social-vkontakte",
    "social-steam",
    ],
    fontAwesome: [
    "glass",
    "music",
    "search",
    "envelope-o",
    "heart",
    "star",
    "star-o",
    "user",
    "film",
    "th-large",
    "th",
    "th-list",
    "check",
    "remove",
    "close",
    "times",
    "search-plus",
    "search-minus",
    "power-off",
    "signal",
    "gear",
    "cog",
    "trash-o",
    "home",
    "file-o",
    "clock-o",
    "road",
    "download",
    "arrow-circle-o-down",
    "arrow-circle-o-up",
    "inbox",
    "play-circle-o",
    "rotate-right",
    "repeat",
    "refresh",
    "list-alt",
    "lock",
    "flag",
    "headphones",
    "volume-off",
    "volume-down",
    "volume-up",
    "qrcode",
    "barcode",
    "tag",
    "tags",
    "book",
    "bookmark",
    "print",
    "camera",
    "font",
    "bold",
    "italic",
    "text-height",
    "text-width",
    "align-left",
    "align-center",
    "align-right",
    "align-justify",
    "list",
    "dedent",
    "outdent",
    "indent",
    "video-camera",
    "photo",
    "image",
    "picture-o",
    "pencil",
    "map-marker",
    "adjust",
    "tint",
    "edit",
    "pencil-square-o",
    "share-square-o",
    "check-square-o",
    "arrows",
    "step-backward",
    "fast-backward",
    "backward",
    "play",
    "pause",
    "stop",
    "forward",
    "fast-forward",
    "step-forward",
    "eject",
    "chevron-left",
    "chevron-right",
    "plus-circle",
    "minus-circle",
    "times-circle",
    "check-circle",
    "question-circle",
    "info-circle",
    "crosshairs",
    "times-circle-o",
    "check-circle-o",
    "ban",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "arrow-down",
    "mail-forward",
    "share",
    "expand",
    "compress",
    "plus",
    "minus",
    "asterisk",
    "exclamation-circle",
    "gift",
    "leaf",
    "fire",
    "eye",
    "eye-slash",
    "warning",
    "exclamation-triangle",
    "plane",
    "calendar",
    "random",
    "comment",
    "magnet",
    "chevron-up",
    "chevron-down",
    "retweet",
    "shopping-cart",
    "folder",
    "folder-open",
    "arrows-v",
    "arrows-h",
    "bar-chart-o",
    "bar-chart",
    "twitter-square",
    "facebook-square",
    "camera-retro",
    "key",
    "gears",
    "cogs",
    "comments",
    "thumbs-o-up",
    "thumbs-o-down",
    "star-half",
    "heart-o",
    "sign-out",
    "linkedin-square",
    "thumb-tack",
    "external-link",
    "sign-in",
    "trophy",
    "github-square",
    "upload",
    "lemon-o",
    "phone",
    "square-o",
    "bookmark-o",
    "phone-square",
    "twitter",
    "facebook-f",
    "facebook",
    "github",
    "unlock",
    "credit-card",
    "feed",
    "rss",
    "hdd-o",
    "bullhorn",
    "bell",
    "certificate",
    "hand-o-right",
    "hand-o-left",
    "hand-o-up",
    "hand-o-down",
    "arrow-circle-left",
    "arrow-circle-right",
    "arrow-circle-up",
    "arrow-circle-down",
    "globe",
    "wrench",
    "tasks",
    "search",
    "briefcase",
    "arrows-alt",
    "group",
    "users",
    "chain",
    "link",
    "cloud",
    "flask",
    "cut",
    "scissors",
    "copy",
    "files-o",
    "paperclip",
    "save",
    "floppy-o",
    "square",
    "navicon",
    "reorder",
    "bars",
    "list-ul",
    "list-ol",
    "strikethrough",
    "underline",
    "table",
    "magic",
    "truck",
    "pinterest",
    "pinterest-square",
    "google-plus-square",
    "google-plus",
    "money",
    "caret-down",
    "caret-up",
    "caret-left",
    "caret-right",
    "columns",
    "unsorted",
    "sort",
    "sort-down",
    "sort-desc",
    "sort-up",
    "sort-asc",
    "envelope",
    "linkedin",
    "rotate-left",
    "undo",
    "legal",
    "gavel",
    "dashboard",
    "tachometer",
    "comment-o",
    "comments-o",
    "flash",
    "bolt",
    "sitemap",
    "umbrella",
    "paste",
    "clipboard",
    "lightbulb-o",
    "exchange",
    "cloud-download",
    "cloud-upload",
    "user-md",
    "stethoscope",
    "suitcase",
    "bell-o",
    "coffee",
    "cutlery",
    "file-text-o",
    "building-o",
    "hospital-o",
    "ambulance",
    "medkit",
    "fighter-jet",
    "beer",
    "h-square",
    "plus-square",
    "angle-double-left",
    "angle-double-right",
    "angle-double-up",
    "angle-double-down",
    "angle-left",
    "angle-right",
    "angle-up",
    "angle-down",
    "desktop",
    "laptop",
    "tablet",
    "mobile-phone",
    "mobile",
    "circle-o",
    "quote-left",
    "quote-right",
    "spinner",
    "circle",
    "mail-reply",
    "reply",
    "github-alt",
    "folder-o",
    "folder-open-o",
    "smile-o",
    "frown-o",
    "meh-o",
    "gamepad",
    "keyboard-o",
    "flag-o",
    "flag-checkered",
    "terminal",
    "code",
    "mail-reply-all",
    "reply-all",
    "star-half-empty",
    "star-half-full",
    "star-half-o",
    "location-arrow",
    "crop",
    "code-fork",
    "unlink",
    "chain-broken",
    "question",
    "info",
    "exclamation",
    "superscript",
    "subscript",
    "eraser",
    "puzzle-piece",
    "microphone",
    "microphone-slash",
    "shield",
    "calendar-o",
    "fire-extinguisher",
    "rocket",
    "maxcdn",
    "chevron-circle-left",
    "chevron-circle-right",
    "chevron-circle-up",
    "chevron-circle-down",
    "html5",
    "css3",
    "anchor",
    "unlock-alt",
    "bullseye",
    "ellipsis-h",
    "ellipsis-v",
    "rss-square",
    "play-circle",
    "ticket",
    "minus-square",
    "minus-square-o",
    "level-up",
    "level-down",
    "check-square",
    "pencil-square",
    "external-link-square",
    "share-square",
    "compass",
    "toggle-down",
    "caret-square-o-down",
    "toggle-up",
    "caret-square-o-up",
    "toggle-right",
    "caret-square-o-right",
    "euro",
    "eur",
    "gbp",
    "dollar",
    "usd",
    "rupee",
    "inr",
    "cny",
    "rmb",
    "yen",
    "jpy",
    "ruble",
    "rouble",
    "rub",
    "won",
    "krw",
    "bitcoin",
    "btc",
    "file",
    "file-text",
    "sort-alpha-asc",
    "sort-alpha-desc",
    "sort-amount-asc",
    "sort-amount-desc",
    "sort-numeric-asc",
    "sort-numeric-desc",
    "thumbs-up",
    "thumbs-down",
    "youtube-square",
    "youtube",
    "xing",
    "xing-square",
    "youtube-play",
    "dropbox",
    "stack-overflow",
    "instagram",
    "flickr",
    "adn",
    "bitbucket",
    "bitbucket-square",
    "tumblr",
    "tumblr-square",
    "long-arrow-down",
    "long-arrow-up",
    "long-arrow-left",
    "long-arrow-right",
    "apple",
    "windows",
    "android",
    "linux",
    "dribbble",
    "skype",
    "foursquare",
    "trello",
    "female",
    "male",
    "gittip",
    "gratipay",
    "sun-o",
    "moon-o",
    "archive",
    "bug",
    "vk",
    "weibo",
    "renren",
    "pagelines",
    "stack-exchange",
    "arrow-circle-o-right",
    "arrow-circle-o-left",
    "toggle-left",
    "caret-square-o-left",
    "dot-circle-o",
    "wheelchair",
    "vimeo-square",
    "turkish-lira",
    "try",
    "plus-square-o",
    "space-shuttle",
    "slack",
    "envelope-square",
    "wordpress",
    "openid",
    "institution",
    "bank",
    "university",
    "mortar-board",
    "graduation-cap",
    "yahoo",
    "google",
    "reddit",
    "reddit-square",
    "stumbleupon-circle",
    "stumbleupon",
    "delicious",
    "digg",
    "pied-piper-pp",
    "pied-piper-alt",
    "drupal",
    "joomla",
    "language",
    "fax",
    "building",
    "child",
    "paw",
    "spoon",
    "cube",
    "cubes",
    "behance",
    "behance-square",
    "steam",
    "steam-square",
    "recycle",
    "automobile",
    "car",
    "cab",
    "taxi",
    "tree",
    "spotify",
    "deviantart",
    "soundcloud",
    "database",
    "file-pdf-o",
    "file-word-o",
    "file-excel-o",
    "file-powerpoint-o",
    "file-photo-o",
    "file-picture-o",
    "file-image-o",
    "file-zip-o",
    "file-archive-o",
    "file-sound-o",
    "file-audio-o",
    "file-movie-o",
    "file-video-o",
    "file-code-o",
    "vine",
    "codepen",
    "jsfiddle",
    "life-bouy",
    "life-buoy",
    "life-saver",
    "support",
    "life-ring",
    "circle-o-notch",
    "ra",
    "resistance",
    "rebel",
    "ge",
    "empire",
    "git-square",
    "git",
    "y-combinator-square",
    "yc-square",
    "hacker-news",
    "tencent-weibo",
    "qq",
    "wechat",
    "weixin",
    "send",
    "paper-plane",
    "send-o",
    "paper-plane-o",
    "history",
    "circle-thin",
    "header",
    "paragraph",
    "sliders",
    "share-alt",
    "share-alt-square",
    "bomb",
    "soccer-ball-o",
    "futbol-o",
    "tty",
    "binoculars",
    "plug",
    "slideshare",
    "twitch",
    "yelp",
    "newspaper-o",
    "wifi",
    "calculator",
    "paypal",
    "google-wallet",
    "cc-visa",
    "cc-mastercard",
    "cc-discover",
    "cc-amex",
    "cc-paypal",
    "cc-stripe",
    "bell-slash",
    "bell-slash-o",
    "trash",
    "copyright",
    "at",
    "eyedropper",
    "paint-brush",
    "birthday-cake",
    "area-chart",
    "pie-chart",
    "line-chart",
    "lastfm",
    "lastfm-square",
    "toggle-off",
    "toggle-on",
    "bicycle",
    "bus",
    "ioxhost",
    "angellist",
    "cc",
    "shekel",
    "sheqel",
    "ils",
    "meanpath",
    "buysellads",
    "connectdevelop",
    "dashcube",
    "forumbee",
    "leanpub",
    "sellsy",
    "shirtsinbulk",
    "simplybuilt",
    "skyatlas",
    "cart-plus",
    "cart-arrow-down",
    "diamond",
    "ship",
    "user-secret",
    "motorcycle",
    "street-view",
    "heartbeat",
    "venus",
    "mars",
    "mercury",
    "intersex",
    "transgender",
    "transgender-alt",
    "venus-double",
    "mars-double",
    "venus-mars",
    "mars-stroke",
    "mars-stroke-v",
    "mars-stroke-h",
    "neuter",
    "genderless",
    "facebook-official",
    "pinterest-p",
    "whatsapp",
    "server",
    "user-plus",
    "user-times",
    "hotel",
    "bed",
    "viacoin",
    "train",
    "subway",
    "medium",
    "yc",
    "y-combinator",
    "optin-monster",
    "opencart",
    "expeditedssl",
    "battery-4",
    "battery",
    "battery-full",
    "battery-3",
    "battery-three-quarters",
    "battery-2",
    "battery-half",
    "battery-1",
    "battery-quarter",
    "battery-0",
    "battery-empty",
    "mouse-pointer",
    "i-cursor",
    "object-group",
    "object-ungroup",
    "sticky-note",
    "sticky-note-o",
    "cc-jcb",
    "cc-diners-club",
    "clone",
    "balance-scale",
    "hourglass-o",
    "hourglass-1",
    "hourglass-start",
    "hourglass-2",
    "hourglass-half",
    "hourglass-3",
    "hourglass-end",
    "hourglass",
    "hand-grab-o",
    "hand-rock-o",
    "hand-stop-o",
    "hand-paper-o",
    "hand-scissors-o",
    "hand-lizard-o",
    "hand-spock-o",
    "hand-pointer-o",
    "hand-peace-o",
    "trademark",
    "registered",
    "creative-commons",
    "gg",
    "gg-circle",
    "tripadvisor",
    "odnoklassniki",
    "odnoklassniki-square",
    "get-pocket",
    "wikipedia-w",
    "safari",
    "chrome",
    "firefox",
    "opera",
    "internet-explorer",
    "tv",
    "television",
    "contao",
    "500px",
    "amazon",
    "calendar-plus-o",
    "calendar-minus-o",
    "calendar-times-o",
    "calendar-check-o",
    "industry",
    "map-pin",
    "map-signs",
    "map-o",
    "map",
    "commenting",
    "commenting-o",
    "houzz",
    "vimeo",
    "black-tie",
    "fonticons",
    "reddit-alien",
    "edge",
    "credit-card-alt",
    "codiepie",
    "modx",
    "fort-awesome",
    "usb",
    "product-hunt",
    "mixcloud",
    "scribd",
    "pause-circle",
    "pause-circle-o",
    "stop-circle",
    "stop-circle-o",
    "shopping-bag",
    "shopping-basket",
    "hashtag",
    "bluetooth",
    "bluetooth-b",
    "percent",
    "gitlab",
    "wpbeginner",
    "wpforms",
    "envira",
    "universal-access",
    "wheelchair-alt",
    "question-circle-o",
    "blind",
    "audio-description",
    "volume-control-phone",
    "braille",
    "assistive-listening-systems",
    "asl-interpreting",
    "american-sign-language-interpreting",
    "deafness",
    "hard-of-hearing",
    "deaf",
    "glide",
    "glide-g",
    "signing",
    "sign-language",
    "low-vision",
    "viadeo",
    "viadeo-square",
    "snapchat",
    "snapchat-ghost",
    "snapchat-square",
    "pied-piper",
    "first-order",
    "yoast",
    "themeisle",
    "google-plus-circle",
    "google-plus-official",
    "fa",
    "font-awesome",
    "handshake-o",
    "envelope-open",
    "envelope-open-o",
    "linode",
    "address-book",
    "address-book-o",
    "vcard",
    "address-card",
    "vcard-o",
    "address-card-o",
    "user-circle",
    "user-circle-o",
    "user-o",
    "id-badge",
    "drivers-license",
    "id-card",
    "drivers-license-o",
    "id-card-o",
    "quora",
    "free-code-camp",
    "telegram",
    "thermometer-4",
    "thermometer",
    "thermometer-full",
    "thermometer-3",
    "thermometer-three-quarters",
    "thermometer-2",
    "thermometer-half",
    "thermometer-1",
    "thermometer-quarter",
    "thermometer-0",
    "thermometer-empty",
    "shower",
    "bathtub",
    "s15",
    "bath",
    "podcast",
    "window-maximize",
    "window-minimize",
    "window-restore",
    "times-rectangle",
    "window-close",
    "times-rectangle-o",
    "window-close-o",
    "bandcamp",
    "grav",
    "etsy",
    "imdb",
    "ravelry",
    "eercast",
    "microchip",
    "snowflake-o",
    "superpowers",
    "wpexplorer",
    "meetup",
    ],
    search: "",
    };
  },
  computed: {
    flaticonList() {
      const self = this;
      let filtered = []
      if (this.search) {
        filtered = this.flaticon.filter((elem)=>{
          return elem.indexOf(self.search) > -1;
        })
      } else {
        filtered = this.flaticon;
      }
      return { list: filtered, filter: this.search };
    },
    flaticon2List() {
      const self = this;
      let filtered = []
      if (this.search) {
        filtered = this.flaticon2.filter((elem)=>{
          return elem.indexOf(self.search) > -1;
        })
      } else {
        filtered = this.flaticon2;
      }
      return { list: filtered, filter: this.search };
    },
    lineAwesomeList() {
      const self = this;
      let filtered = []
      if (this.search) {
        filtered = this.lineAwesome.filter((elem)=>{
          return elem.indexOf(self.search) > -1;
        })
      } else {
        filtered = this.lineAwesome;
      }
      return { list: filtered, filter: this.search };
    },
    simpleLinesList() {
      const self = this;
      let filtered = []
      if (this.search) {
        filtered = this.simpleLines.filter((elem)=>{
          return elem.indexOf(self.search) > -1
        })
      } else {
        filtered = this.simpleLines;
      }
      return { list: filtered, filter: this.search };
    },
    fontAwesomeList() {
      const self = this;
      let filtered = []
      if (this.search) {
        filtered = this.fontAwesome.filter((elem)=>{
          return elem.indexOf(self.search) > -1
        })
      } else {
        filtered = this.fontAwesome;
      }
      return { list: filtered, filter: this.search };
    }
  }
}
</script>


<style lang="scss" scoped>
.wrap {
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  padding: 2rem;
}
.wrap i {
  margin-right: 1rem;
  font-size:2rem;
}
</style>
